angular
  .module('estoffice.legacy')
  .controller('BasicSidebarCtrl', basicSidebarCtrl);

function basicSidebarCtrl($scope, $rootScope, request, api) {
  $scope.markedOffice = false;
  $scope.activateOffices = function (event) {
    event.preventDefault();
    $scope.markedOffice = !$scope.markedOffice;
  };

  $scope.changeBuildingPhase = function () {
    var url = api.basic.buildingPhase.replace(
      '{{sectionId}}',
      $rootScope.sectionId,
    );
    if ($scope.buildingPhase != '...') {
      var data = {
        construction_phase: $scope.buildingPhase,
        token: $rootScope.token,
      };
      request.post(url, data);
    }
  };
}
